<template>
  <div class="wwi-button-group">
    <button
      class="wwi-button wwi-button-secondary"
      @click="$router.go(-1)"
    >
      {{ $t('general.actions.back') }}
    </button>
    <button
      class="wwi-button"
      :class="{ 'wwi-button--isLoading': isLoading }"
      @click="$emit('continue')"
    >
      {{ $t('general.actions.continue') }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      default: 1,
      type: Number
    },
    title: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      totalSteps: 4
    }
  },
  computed: {
    isLoading () {
      return this.$store.getters['userdata/isLoading']
    }
  }
}
</script>

<style lang="scss">
  .wwi-button--isLoading {
    &::before {
      content: '';
      display: inline-block;
      width: 1em;
      height: 1em;
      border-radius: 50%;
      background-color: #fff;
      vertical-align: middle;
      animation: loading 2s ease-in-out infinite;
    }
  }

  @keyframes loading {
    0% {
      opacity: 0.5;
      transform: scale(0.5);
    }
    50% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: 0.5;
      transform: scale(0.5);
    }
  }

  .wwi-button-group {
    text-align: right;
  }
</style>
